import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { routerShape } from 'react-router/lib/PropTypes';
import Icon, { GLYPHS } from '../../common/icon';
import logo from '../../../../images/logo.svg';

class SignUp extends Component {
  onSubmit = e => {
    e.preventDefault();
    const { username, password } = this.refs;
    const { signUpUser } = this.props;
    signUpUser(username.value.trim(), password.value.trim()).then(() => {
      this.props.router.push('/login');
    });
  };

  render() {
    let err = null;
    const { signUpError } = this.props;

    if (signUpError) {
      err = (<div className="c-error-message u-mb">{signUpError}</div>);
    }

    return (
      <form onSubmit={this.onSubmit} className="c-inner-wrapper u-max-width-400 u-position-relative u-mt++">
        <div className="c-logo-login">
          <img src={logo} />
        </div>

        <div className="c-heading c-heading--semibold c-heading--large u-text-center u-mv">Welcome, sign up!</div>
        {err}
        <div className="c-label-new">Email</div>
        <input ref="username" type="text" className="c-input c-input--large u-pl-" placeholder="Email" name="username" defaultValue="basic_user@squirebasic.com" />
        <div className="c-label-new u-mt">Password</div>
        <input ref="password" type="password" className="c-input c-input--large u-pl- u-mb-" placeholder="Password" name="password" defaultValue="basic_password" />
        <div className="o-flexbox u-pt">

          <div className="o-flexbox__item o-flexbox__item--flex-start">
            <button type="submit" className="c-btn">
              <Icon glyph={GLYPHS.save} size="medium" />
              <span className="c-btn__text">Sign Up</span>
            </button>
          </div>
        </div>
      </form>
    );
  }
}

SignUp.propTypes = {
  signUpError: PropTypes.string,
  signUpUser: PropTypes.func.isRequired,
  router: routerShape.isRequired,
};

export default SignUp;
